import Dexie, { type Table } from "dexie";

const DB_NAME = "encryption";

interface KeyStore {
  id: string;
  key: CryptoKey;
}

class KeyDatabase extends Dexie {
  keys!: Table<KeyStore>;

  constructor() {
    super(DB_NAME);
    this.version(1).stores({
      keys: "id",
    });
    // Clear old data on upgrade to handle schema changes from previous versions
    this.on("populate", () => {
      // This runs on first initialization
    });
  }
}

const db = new KeyDatabase();

// Handle database initialization and cleanup
db.open().catch((error) => {
  if (error.name === "UpgradeError" || error.name === "DatabaseClosedError") {
    // Delete the old database and recreate it
    return Dexie.delete(DB_NAME).then(() => {
      location.reload();
    });
  }
  throw error;
});

export async function saveKeyToDB(key: CryptoKey): Promise<void> {
  await db.keys.put({ id: "dek", key });
}

export async function loadKeyFromDB(): Promise<CryptoKey | undefined> {
  const record = await db.keys.get("dek");
  return record?.key;
}

export async function clearKeyFromDB(): Promise<void> {
  await db.keys.delete("dek");
}
